export const getAppRecommendationTypes = result => {
  if (!result.recommendation) {
    return null;
  }
  return result.recommendation.sourceVersions.map(({
    source,
    version
  }) => `${source}-v${version}`);
};
export const getBatchAppRecommendationTypes = results => {
  return results.reduce((final, result) => {
    const recommendationTypes = getAppRecommendationTypes(result);
    if (recommendationTypes) {
      final.push(...recommendationTypes.filter(value => !final.includes(value)));
    }
    return final;
  }, []);
};